import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

import useLinkForTherapist from '@/legacy-src/hooks/useLinkForTherapist'

import { type AuthorType } from '../onlineLessons/types'

type Props = {
  readonly citation: {
    citation: string
    author: AuthorType
  }
  readonly isPublic?: boolean
}

const Citation: React.FC<Props> = ({ citation, isPublic = false }) => {
  const author = citation?.author
  const image = author?.thumbnail?.data?.attributes?.url

  const linkForTherapist = useLinkForTherapist(author?.therapistId, isPublic)

  const link = linkForTherapist || author?.instagramLink

  return (
    <div>
      <div className={`m-2 rounded-2xl ${isPublic ? 'bg-blue-500' : 'bg-white'} p-8 font-bold`}>
        <div className="mb-4 text-petrol-500">{citation?.citation}</div>
        <div className="flex flex-wrap items-center">
          {image && (
            <div className="relative mr-3 h-[70px] w-[70px] overflow-hidden !rounded-full bg-white">
              <Image src={image} alt={author?.name} fill objectFit="cover" sizes="70px" />
            </div>
          )}
          <div>
            {link ? (
              <Link className="text-peach-500 hover:text-peach-500" href={link}>
                <div>{author?.name}</div>
              </Link>
            ) : (
              <div className="text-peach-500">{author?.name}</div>
            )}
            <div className="text-text-color">{author?.instagramName}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Citation
